import React from 'react';

// Subtle, non-interactive floating petals used as background ambience.
// Pointer-events are disabled so it never blocks interaction.
export default function FloatingPetals({ count = 6, opacity = 0.5, colors }) {
  const palette = colors || [
    'radial-gradient(circle at 30% 30%, #F4C0C4, #E8A5A9 60%, rgba(232,165,169,0) 75%)',
    'radial-gradient(circle at 35% 30%, #F8D5D9, #E8A5A9 65%, rgba(232,165,169,0) 78%)',
    'radial-gradient(circle at 40% 25%, #FBE1E5, #F4C0C4 60%, rgba(244,192,196,0) 78%)',
  ];
  const petals = Array.from({ length: count });

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-[1]" aria-hidden="true">
      {petals.map((_, i) => (
        <span
          key={i}
          className="petal absolute"
          style={{
            left: `${(i * 17 + 6) % 96}%`,
            top: `${-12 - ((i * 9) % 40)}%`,
            width: `${9 + (i % 3) * 5}px`,
            height: `${9 + (i % 3) * 5}px`,
            background: palette[i % palette.length],
            borderRadius: '60% 40% 55% 45%',
            filter: 'blur(0.5px)',
            opacity,
            animationDelay: `${i * 3.2}s`,
            animationDuration: `${28 + (i % 5) * 4}s`,
          }}
        />
      ))}
    </div>
  );
}
